var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportMainTabFiledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM19.8535 7.64645C19.953 7.74586 20.0018 7.87671 19.9999 8.007V12.0909C19.9999 12.3671 19.7761 12.5909 19.4999 12.5909C19.2238 12.5909 18.9999 12.3671 18.9999 12.0909V9.20715L13.3763 14.8308C13.2825 14.9246 13.1553 14.9773 13.0227 14.9773C12.8901 14.9773 12.7629 14.9246 12.6692 14.8308L9.61363 11.7753L4.85355 16.5354C4.65829 16.7306 4.3417 16.7306 4.14644 16.5354C3.95118 16.3401 3.95118 16.0235 4.14644 15.8283L9.26008 10.7146C9.35385 10.6209 9.48102 10.5682 9.61363 10.5682C9.74624 10.5682 9.87342 10.6209 9.96719 10.7146L13.0227 13.7702L18.2929 8.5H15.409C15.1329 8.5 14.909 8.27614 14.909 8C14.909 7.72386 15.1329 7.5 15.409 7.5H19.4999L19.5078 7.50006C19.5652 7.50095 19.6203 7.51151 19.6715 7.5302C19.7379 7.55441 19.8003 7.59315 19.8535 7.64645Z",
    fill: "url(#paint0_linear_78_9161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_9161",
    x1: 1.2,
    y1: 12,
    x2: 21.2431,
    y2: 22.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8747F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D60F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportMainTabFiledIcon);
export default __webpack_public_path__ + "static/media/report-main-tab-filed-icon.bf6d44073939cbad7f430202764a624c.svg";
export { ForwardRef as ReactComponent };